import { IStorage } from '@app/core/interface/storage';

export abstract class BaseStorage implements IStorage {
  protected storage: Storage;
  private isSupported = false;

  constructor() {
    this.createStorage();
    this.isSupported = this.canBeUsed();
  }

  /**
   * @param {string} key
   * @returns {string}
   */
  public find(key: string): string {
    let result = null;

    if (this.isSupported) {
      result = this.storage.getItem(key);
    }

    return result;
  }

  /**
   * @param {string} key
   * @param {string} value
   * @returns {boolean}
   */
  public create(key: string, value: string): boolean {
    let result = false;

    if (this.isSupported) {
      try {
        this.storage.setItem(key, value);
        result = true;
      } catch (e) {}
    }

    return result;
  }

  /**
   * @param {string} key
   * @returns {boolean}
   */
  public remove(key: string): boolean {
    let result = false;

    if (this.isSupported) {
      if (this.storage.getItem(key)) {
        this.storage.removeItem(key);
        result = true;
      }
    }

    return result;
  }

  /**
   * @returns {boolean}
   */
  private canBeUsed(): boolean {
    let result = true;

    try {
      const x = 'test';

      this.storage.setItem(x, x);
      this.storage.removeItem(x);
    } catch (e) {
      result = false;
    }

    return result;
  }

  protected abstract createStorage(): void;
}
